module.exports = __webpack_public_path__ + "static/bg-marrom-247c8c31ae8c042a29cbeb089b902fc7.jpg";